<template>
  <div class="orga">
    <div class="area P3">
      <div class="d d_gl">
        <s-header :name="'您正在处理组织相关工作，祝您工作愉快~'" :type="2"></s-header>
        <ul class="u2 u_zz">
          <li @click="verify()">
            <p class="a_zz a_zz1">
              <span class="s_num" v-if="auditTotal > 0">{{ auditTotal }}</span>
            </p>
          </li>
          <li @click="accout()">
            <p class="a_zz a_zz2">
              <span class="s_num" v-if="pwdTotal > 0">{{ pwdTotal }}</span>
            </p>
          </li>
          <!-- <li @click="address()"><p class="a_zz a_zz3"></p></li> -->
          <!-- <li @click="statistics()"><p class="a_zz a_zz4"></p></li> -->
        </ul>
      </div>
    </div>
    <nav-bar />
  </div>
</template>
<script>
import { onMounted, reactive, toRefs } from "vue";
import navBar from "@/components/NavBar";
import { useStore } from "vuex";
import sHeader from "@/components/SimpleHeader";
import { useRouter } from "vue-router";
import { getReport } from "@/service/report";
// getRoleId
import { tipsMsg, getLocal, setLocal } from "@/common/js";
import { getCurrentInfo } from "@/service/user";
export default {
  components: {
    navBar,
    sHeader,
  },

  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      auditTotal: 0,
      pwdTotal: 0,
    });
    onMounted(() => {
      getTotal();
      const dsjstore = getLocal("dsj_store");
      
      if (dsjstore) {
        const storeInfo = JSON.parse(dsjstore);
        if (storeInfo.info.roleList.length == 0) {
          userInfo();
        }
      } else {
        userInfo();
         setLocal("dsj_store", JSON.stringify(store.state));
      }
    });


    const getTotal = async () => {
      const {
        code,
        data: { auditTotal, pwdTotal },
        message,
      } = await getReport();
      if (code === 10000) {
        state.auditTotal = auditTotal;
        state.pwdTotal = pwdTotal;
      } else {
        tipsMsg("提示", message);
      }
    };

    // 获取当前用户的身份信息
    const userInfo = async () => {
      const { data, code } = await getCurrentInfo();
      if (code === 10000) {
        const {
          roleList,
          city,
          district,
          province,
          provinceCode,
          cityCode,
          districtCode,
        } = data;
        store.commit("info/SET_ROLELIST", roleList);
        store.commit("info/SET_AREA", {
          province,
          city,
          district,
          provinceCode,
          cityCode,
          districtCode,
        });
      }
    };
    // 审核填报信息
    const verify = () => {
      console.log("审核填报信息");
      let status = state.auditTotal > 0 ? 0 : 1;

      router.push({ path: "/organization/auditor", query: { status } });
    };

    // 管理成员账号
    const accout = () => {
      console.log("accout");
      const isVerify = state.pwdTotal > 0 ? true : false;
      router.push({ path: "/organization/adminAccount", query: { isVerify } });
    };

    // 通讯录
    const address = () => {
      console.log("address");
      router.push({ path: "/organization/mailList" });
    };

    // 统计结果
    const statistics = async () => {
      // const rId = await getRoleId();
      
      // if (rId <= 2) {
        router.push({ path: "/organization/infoStatistics" });
      // } else {
      //   Dialog.alert({
      //     message: "敬请期待~",
      //   }).then(() => {});
      // }
    };
    return {
      ...toRefs(state),
      verify,
      accout,
      address,
      statistics,
      userInfo,
    };
  },
};
</script>
<style lang="less" scoped>
.orga {
  flex: 1;
}
</style>
